export default __webpack_public_path__ + "static/media/sportsbra-large-left.3cc85bc6.jpg";